import React from 'react';
import HookForm from '../components/HookForm';
import { MOTSETSIM_TERMS_LINK } from '../utils/constants'

const CouponFormContainer = ({
    intro,
    legal,
    termsLink,
}) => {
    return (
        <>
            {!!intro && intro}
            <HookForm
                legal={legal}
                termsLink={termsLink}
                motsetsimTermsLink={MOTSETSIM_TERMS_LINK}
            />
        </>
    );
};

export default CouponFormContainer;
